const GA_MEASUREMENT_ID = 'G-6HKBE6EDV8'

declare global {
  interface Window {
    dataLayer: unknown[]
    gtag: (...args: unknown[]) => void
  }
}

/**
 * Injects the Google tag (gtag.js) as the first elements inside <head>,
 * matching Google's recommended snippet. Safe to call more than once.
 */
export function initGoogleAnalytics(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (document.getElementById('ga-gtag-loader')) return

  const loader = document.createElement('script')
  loader.id = 'ga-gtag-loader'
  loader.async = true
  loader.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`

  const inline = document.createElement('script')
  inline.id = 'ga-gtag-config'
  inline.text = [
    'window.dataLayer = window.dataLayer || [];',
    'function gtag(){dataLayer.push(arguments);}',
    "gtag('js', new Date());",
    `gtag('config', '${GA_MEASUREMENT_ID}');`,
  ].join('\n')

  const head = document.head
  // Insert immediately after the opening <head> tag, loader first.
  head.insertBefore(inline, head.firstChild)
  head.insertBefore(loader, inline)
}
